<template>
  <div class="camera-monitor">
    <div class="caption pl-2 font-weight-bold">カメラ一覧</div>
    <v-card class="d-flex flex-wrap" tile flat color="#F5F5F5">
      <v-card
        v-for="(station, index) in stations"
        :key="station.id"
        class="pa-2"
        :width="cardWidth"
        tile
        flat
        color="#F5F5F5"
      >
        <div
          class="station-area"
          flat
          tile
          outlined
          @click="moveStation(station)"
        >
          <v-card height="50" flat tile>
            <div class="body-2">{{ index + 1 + ". " + station.name }}</div>
            <div class="caption" v-if="station.address">
              {{ station.address }}
            </div>
          </v-card>
          <v-img
            v-if="station.url"
            :width="cardWidth - 30"
            :height="(cardWidth - 30) / 2"
            :src="station.url"
          />
          <v-img
            v-else
            :width="cardWidth - 30"
            :height="(cardWidth - 30) / 2"
            :src="require('@/assets/images/camera-none.jpg')"
            contain
          />
          <div class="caption">{{ station.date }}</div>
        </div>
      </v-card>
    </v-card>
  </div>
</template>
<script>
import * as axiosHelper from "../utils/axiosHelper";
import moment from "moment";
export default {
  name: "MobileCameraMonitor",
  components: {},
  data() {
    return {
      windowWidth: window.innerWidth,
      stations: [],
      imageWindow: null
    };
  },

  computed: {
    cameras() {
      const observatories = this.$store.getters.observatories;
      const cameras = observatories.filter(obs => obs.type === 30);
      cameras.sort((a, b) => {
        // 緯度降順
        if (a.lat > b.lat) return -1;
        if (a.lat < b.lat) return 1;
        return 0;
      });
      return cameras;
    },
    rowPanelNum() {
      const num = Math.floor(this.windowWidth / 650);
      if (num < 1) {
        return 1;
      } else {
        return num + 1;
      }
    },
    cardWidth() {
      return Math.floor(this.windowWidth / this.rowPanelNum);
    },
    baseDate() {
      return this.$store.getters.baseDate;
    }
  },

  watch: {
    baseDate(newval, oldval) {
      if (!newval.isSame(oldval)) {
        this.sync();
      }
    }
  },

  async created() {
    await this.$store.dispatch("FETCH_OBSERVATORIES");
    window.addEventListener("resize", this.resizeWindow);
    this.sync();
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.resizeWindow);
  },

  mounted() {
    //
  },

  methods: {
    resizeWindow() {
      this.windowWidth = window.innerWidth;
    },
    close() {
      this.$store.commit("SET_IS_CAMERA_MONITOR", false);
    },
    moveStation(station) {
      if (!station.url) {
        return;
      }
      const url = `image.html?url=${station.url}`;
      if (this.imageWindow === null || this.imageWindow.closed === true) {
        this.imageWindow = window.open(url);
      } else {
        this.imageWindow.location.href = url;
        setTimeout(() => {
          this.imageWindow.focus();
        }, 500);
      }
    },
    async sync() {
      this.stations = [];
      const processes = this.cameras.map(target => {
        return (async () => {
          const params = {
            date: this.baseDate.format("YYYY/MM/DD HH:mm"),
            id: target.id,
            type: 30
          };
          if (target.bucket) {
            params["bucket"] = target.bucket;
          }
          if (target.prefix) {
            params["prefix"] = target.prefix;
          }
          const row = { ...target };
          row.date = "";
          row.url = "";
          this.stations.push(row);
          const response = await axiosHelper.get("/observatories/data", params);
          if (response !== null && response.timeSeries) {
            const cameraData = response.timeSeries;
            if (cameraData && cameraData.length > 0) {
              const latest = cameraData[cameraData.length - 1];
              row.date = moment
                .utc(latest.date)
                .local()
                .format("YYYY年M月D日 HH時mm分");
              row.url = latest.url;
            }
          }
        })();
      });
      await Promise.all(processes);
    }
  }
};
</script>

<style lang="scss" scoped>
.station-area {
  background-color: white;
  padding: 8px 14px;
  cursor: pointer;
  border: 1px solid rgb(228, 228, 228);
}

.camera-monitor {
  background-color: #f5f5f5;
}
</style>
